import {
    makeStyles,
} from 'app/tss'

const useStyles = makeStyles()(() => {
    return {
        taxClassification: {
            width: '50% !important',
        },
    }
})

export default useStyles
